module.exports = __webpack_public_path__ + "static/media/detail_0013_t.12c62179.jpg";